export default {
    settings: {
        title: 'Settings',
        description: 'Customize and view in real time',
        language: {
            title: 'Language',
            russian: 'Русский',
            english: 'English'
        },
        workspace: 'Workspace',
        fix_panel: 'Fix left panel',
        color_scheme: {
            title: 'Color scheme',
            standart: 'Standard',
            dark: 'Dark',
        },
        stringHeight: 'Max number of lines in a string',
        help: 'The order of the columns can be changed - by selecting the desired column and drag it up or down.',
        notification: 'Notifications',
    }
};
